import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { api } from "../lib/api";
import { Loader2, Printer, ArrowLeft } from "lucide-react";

export function PrintQR() {
  const [players, setPlayers] = useState(null);

  useEffect(() => {
    api.get("/players").then((r) => setPlayers(r.data)).catch(() => setPlayers([]));
  }, []);

  const origin = useMemo(() => window.location.origin, []);

  if (players === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <style>{`@media print { .no-print { display: none !important; } @page { margin: 12mm; } }`}</style>

      <div className="no-print sticky top-0 z-10 bg-white border-b border-slate-200">
        <div className="max-w-5xl mx-auto px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-emerald-600 text-sm font-semibold" data-testid="printqr-back">
            <ArrowLeft className="w-4 h-4" /> Torna al campionato
          </Link>
          <button
            data-testid="printqr-print-btn"
            onClick={() => window.print()}
            className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold uppercase text-xs tracking-wide"
          >
            <Printer className="w-4 h-4" /> Stampa
          </button>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 py-8" data-testid="printqr-page">
        <div className="text-center mb-8">
          <h1 className="font-display font-black uppercase tracking-tight text-3xl text-slate-900">American Padel 2026</h1>
          <p className="text-slate-500 mt-1">Inquadra il QR del giocatore per aprire il suo profilo e seguire la classifica</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5">
          {players.map((p) => (
            <div key={p.id} data-testid={`printqr-card-${p.id}`} className="border border-slate-300 rounded-2xl p-4 flex flex-col items-center gap-3 break-inside-avoid">
              <QRCodeCanvas value={`${origin}/p/${p.id}`} size={132} fgColor="#0B0F19" bgColor="#ffffff" level="M" />
              <div className="text-center">
                <div className="font-semibold text-slate-900 leading-tight">{p.name}</div>
                <div className="text-[11px] text-slate-500 font-mono">americanpadel.it/p/{p.id}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
